var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.cssClass,attrs:{"variant":"secondary","type":"button","to":_vm.to}},[_vm._v(" "+_vm._s(_vm.isNullOrEmpty(_vm.backTo) ? _vm.text : 'Back to ' + _vm.backTo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }